module.exports = [{"value":0,"label":"完整版"},{"value":1,"label":"Live"},{"value":2,"label":"Remix"},{"value":4,"label":"伴奏"},{"value":8,"label":"Demo"},{"value":9,"label":"其他"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/song_version.json
// module id = NQef
// module chunks = 1